import { apiClient } from '_shared/dataFetching/apiConfig';
import { getLocalStorageAuthTokens } from '_shared/utils/localStorage';
import isEmpty from 'lodash/isEmpty';
import { getCurrentEnvironment } from '_shared/utils/environment/currentEnv';

const userData = getLocalStorageAuthTokens();
const userName = userData.userName;

let attributes = {};

const currentEnv = getCurrentEnvironment();

export const log = async (inputAttributes) => {
  if (currentEnv === 'dev') {
    console.dir(`DEVLOG:  ${inputAttributes?.message}`);
  } else {
    if (isEmpty(inputAttributes)) {
      attributes = {
        site: 'tv-collection-client',
        path: window.location.href,
        userAgent: navigator.userAgent,
        userName,
        level: 'ERROR',
        message: 'Could not send error log message, attributes object empty'
      };
    } else {
      attributes = {
        site: 'tv-collection-client',
        path: window.location.href,
        userAgent: navigator.userAgent,
        userName,
        level: inputAttributes?.level,
        message: trimLogMessage(inputAttributes?.message)
      };
    }
    const postObject = { attributes };
    await apiClient.post('log', postObject);
  }
};

export const logBasicMessage = (level, message) => {
  log({
    level,
    message
  });
};

export function trimLogMessage(message) {
  if (message.length > 350) {
    return message.slice(0, 350);
  }
  return message;
}
